<template>
  <v-card outlined class="mt-2">
    <v-card-title class="subtitle-2 py-2 d-flex align-center">
      <v-icon small left color="green">mdi-whatsapp</v-icon>
      Conversación Twilio
      <v-chip x-small class="ml-2" v-if="totalMensajes">{{ totalMensajes }} mensajes</v-chip>
      <v-spacer></v-spacer>
      <v-btn icon x-small :loading="cargando" @click="cargarConversacion" title="Recargar">
        <v-icon small>mdi-refresh</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="pa-3 conversacion-panel" ref="panelConversacion">
      <div v-if="!usuarioTwilio" class="text-center py-6 grey--text text-body-2">
        Sin teléfono Twilio para cargar la conversación.
      </div>
      <div v-else-if="cargando && !mensajes.length" class="text-center py-6">
        <v-progress-circular indeterminate color="primary" size="28"></v-progress-circular>
        <div class="text-caption grey--text mt-2">Cargando conversación...</div>
      </div>
      <div v-else-if="!mensajes.length" class="text-center py-6 grey--text text-body-2">
        Sin mensajes para este contacto.
      </div>
      <div v-else>
        <div v-for="(m, i) in mensajes" :key="i">
          <div v-if="mostrarCabeceraFecha(i)" class="d-flex justify-center py-3">
            <v-chip x-small color="grey lighten-3" class="text-caption grey--text text--darken-2 px-4">
              {{ formatearFechaChat(m.fecha_creacion) }}
            </v-chip>
          </div>
          <div :class="esMio(m) ? 'd-flex justify-end mb-3' : 'd-flex justify-start mb-3'">
            <div :class="['chat-bubble shadow-sm', esMio(m) ? 'bubble-bot' : 'bubble-lead']">
              <div class="d-flex align-center mb-1">
                <v-icon x-small :color="esMio(m) ? 'indigo' : 'green'" class="mr-1">
                  {{ esMio(m) ? 'mdi-robot' : 'mdi-account' }}
                </v-icon>
                <span class="text-overline font-weight-bold emisor-label">{{ etiquetaEmisor(m) }}</span>
              </div>
              <div v-if="m.mensaje" class="text-body-2 mensaje-texto">{{ m.mensaje }}</div>
              <div v-if="m.MediaUrl0" class="mt-2">
                <v-img
                  v-if="esImagen(m)"
                  :src="urlMedia(m)"
                  max-width="220"
                  max-height="200"
                  contain
                  class="rounded grey lighten-4"
                ></v-img>
                <v-chip v-else small label @click="abrirMedia(m)">
                  <v-icon left small>mdi-paperclip</v-icon>
                  Ver adjunto
                </v-chip>
              </div>
              <div v-if="!m.mensaje && !m.MediaUrl0" class="font-italic grey--text text-caption">
                [Mensaje multimedia / sistema]
              </div>
              <div class="bubble-time text-right mt-1 grey--text">
                {{ horaMensaje(m.fecha_creacion) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import validarErrores from '@/mixins/validarErrores'
import { normalizarUsuarioTwilio } from '@/utils/twilioUsuario'

export default {
  name: 'ConversacionTwilioLectura',

  mixins: [validarErrores],

  props: {
    escuela: { type: [Number, String], required: true },
    twilio: { type: String, default: '' },
    telefono: { type: String, default: '' },
    autoCargar: { type: Boolean, default: true },
  },

  data: () => ({
    mensajes: [],
    cargando: false,
    urlTwilioLead: 'https://testfast.club/imagenes-whatsapp/',
    urlTwilioBot: 'https://escuelakpi.club/imagenes-whatsapp/',
  }),

  computed: {
    usuarioTwilio() {
      return normalizarUsuarioTwilio(this.twilio, this.telefono)
    },

    escuelaTwilio() {
      const n = Number(this.escuela)
      return n === 1 || n === 2 ? n : 2
    },

    totalMensajes() {
      return this.mensajes.length
    },
  },

  watch: {
    usuarioTwilio: {
      immediate: true,
      handler(val) {
        if (val && this.autoCargar) this.cargarConversacion()
        else if (!val) this.mensajes = []
      },
    },
  },

  methods: {
    cargarConversacion() {
      if (!this.usuarioTwilio) return

      this.cargando = true

      // Mismo endpoint y modo que Twilio Unificado: todas las tablas + API Twilio
      const payload = {
        usuario: this.usuarioTwilio,
        modo: true,
        escuela: this.escuelaTwilio,
      }

      return this.$http
        .post('twilio.chats.unico', payload)
        .then((response) => {
          const lista = (response.data && response.data.conversacionCompleta) || []
          this.mensajes = lista.sort(
            (a, b) => new Date(a.fecha_creacion) - new Date(b.fecha_creacion)
          )
          this.$nextTick(() => this.scrollAlFinal())
        })
        .catch((error) => {
          const mensaje =
            (error.body && error.body.message) ||
            (error.response && error.response.data && error.response.data.message) ||
            'No se pudo cargar la conversación'
          this.validarError(mensaje)
          this.mensajes = []
        })
        .finally(() => {
          this.cargando = false
        })
    },

    esMio(m) {
      return Number(m.mio) === 1
    },

    etiquetaEmisor(m) {
      if (!this.esMio(m)) return 'Lead'
      return m.nombre_completo || 'Bot / Asesor'
    },

    scrollAlFinal() {
      const panel = this.$refs.panelConversacion
      if (panel) panel.scrollTop = panel.scrollHeight
    },

    parseFecha(fecha) {
      if (!fecha) return null
      const texto = String(fecha).replace(' ', 'T')
      const d = new Date(texto)
      return isNaN(d.getTime()) ? null : d
    },

    mostrarCabeceraFecha(index) {
      if (index === 0) return true
      const actual = this.parseFecha(this.mensajes[index].fecha_creacion)
      const previa = this.parseFecha(this.mensajes[index - 1].fecha_creacion)
      if (!actual || !previa) return false
      return actual.toDateString() !== previa.toDateString()
    },

    formatearFechaChat(fecha) {
      const d = this.parseFecha(fecha)
      if (!d) return ''
      const hoy = new Date()
      const ayer = new Date()
      ayer.setDate(hoy.getDate() - 1)
      if (d.toDateString() === hoy.toDateString()) return 'Hoy'
      if (d.toDateString() === ayer.toDateString()) return 'Ayer'
      return d.toLocaleDateString('es-MX', { weekday: 'long', day: 'numeric', month: 'long' })
    },

    horaMensaje(fecha) {
      const d = this.parseFecha(fecha)
      if (!d) return ''
      return d.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })
    },

    esImagen(m) {
      return Number(m.type) === 2
    },

    urlMedia(m) {
      if (!m.MediaUrl0) return ''
      if (String(m.MediaUrl0).startsWith('http')) return m.MediaUrl0
      const base = this.esMio(m) ? this.urlTwilioBot : this.urlTwilioLead
      return base + m.MediaUrl0
    },

    abrirMedia(m) {
      const url = this.urlMedia(m)
      if (url) window.open(url, '_blank')
    },
  },
}
</script>

<style scoped>
.conversacion-panel {
  max-height: 420px;
  overflow-y: auto;
  background: #e5ddd5;
  background-image: url('https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png');
  background-blend-mode: overlay;
}

.chat-bubble {
  max-width: 85%;
  padding: 8px 12px;
  border-radius: 16px;
  font-size: 0.85rem;
  line-height: 1.2rem;
}

.bubble-lead {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  color: #212121;
  border-bottom-left-radius: 4px;
}

.bubble-bot {
  background-color: #dcf8c6;
  border: 1px solid #c8e6b5;
  color: #1b5e20;
  border-bottom-right-radius: 4px;
}

.emisor-label {
  line-height: 1;
  font-size: 0.6rem !important;
}

.mensaje-texto {
  word-break: break-word;
  white-space: pre-line;
}

.bubble-time {
  font-size: 0.6rem;
}

.shadow-sm {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
</style>
